import { Box } from '@chakra-ui/react';

export default function OSXHeader() {
	return (
		<Box display="flex" alignItems="center" bg="gray.200" p="1" position="relative">
			<Box display="inline-block" bg="red.400" w="3" h="3" borderRadius="full" mr="2" ml="1" />
			<Box display="inline-block" bg="yellow.400" w="3" h="3" borderRadius="full" mr="2" ml="0" />
			<Box display="inline-block" bg="green.400" w="3" h="3" borderRadius="full" mr="2" ml="0" />
		</Box>
	);
}
